<template>
  <div
    class="sale-box-bar"
    v-if="!product.purchaseOnRequestArticle"
  >
    <div class="sale-box-bar__product-name-wrapper">
      <div class="sale-box-bar__product-name">
        {{ product.name }}
      </div>
      <availability-info
        class="sale-box-bar__availability"
        v-if="!product.inBasket && !product.zeroPriceItem && !product.recurringOrderFollowUpPacket"
        :availability="product.availability"
      />
    </div>
    <div
      v-if="!isPriceInfoVisible()"
      class="sale-box__zero-price-wrapper"
    >
      <div class="sale-box__buttons">
        <span class="product-box__status product-box__status--unavailable">
          {{ $t('availability.no-price') }}
        </span>
      </div>
    </div>
    <div
      v-else
      class="sale-box-bar__conversion-wrapper"
    >
      <div
        class="sale-box-bar__savedPercentage sale-box__price--savedPercentage"
        v-if="product.price.savedPercentage"
      >
        -{{ product.price.savedPercentage }}%
      </div>
      <product-navigation-price-info
        class="sale-box-bar__price"
        :value="product.price"
        :show-tax="true"
        :shipping-info-url="product.shippingInfoUrl"
        :show-shipping-included="product.deliveryCostIncluded"
        :with-savings-max="productDetails.pageType === 'AQ_LANDING_PAGE'"
      />
      <template
        v-if="onePageCheckout"
      >
        <button
          class="sale-box__button-opc | button button--secondary-arrow"
          type="button"
          @click="scrollToCheckout()"
        >
          {{ $t('onepagecheckout.go_to_checkout') }}
        </button>
      </template>
      <template
        v-else-if="!productDetails.product.zeroPriceItem && productDetails.product.recurringOrderFollowUpPacket"
      >
        <div class="sale-box__buttons">
          <div class="product-box__status product-box__status--unavailable">
            {{ $t('product.button.recurringOrderFollowUpPacket') }}
          </div>
        </div>
      </template>
      <template
        v-else-if="product.availability.available && !product.inBasket && !addToBasketHtmlReplacement"
      >
        <counter-input
          class="sale-box-bar__counter"
          :counter="product.counter"
          @update="counterChangeHandler"
          ref="quantity"
        />

        <button
          class="sale-box-bar__add-to-basket | button button--add-to-basket"
          :class="{
            'button--loading': state === 'loadingBasket'
          }"
          type="button"
          @click="addToBasket"
        />
      </template>
      <a
        class="sale-box__status-basket"
        v-if="product.inBasket"
        :href="basketUrl"
      >
        {{ $t('ads.ads_top_info.article_in_basket') }}
      </a>
    </div>
  </div>
</template>

<script lang="ts">
  import {Vue, Options, Prop, Watch} from 'vue-property-decorator';
  import productStore from '../../../bps/stores/product/ProductStore';
  import productPageService from '../../../bps/services/product/ProductPageService';
  import type Product from '../../../bps/types/Product';
  import AvailabilityInfo from '../../../bps/components/availabilityInfo/availabilityInfo.vue';
  import * as scrollToElement from 'scroll-to-element';
  import ProductNavigationPriceInfo
    from '../productNavigationPriceInfo/productNavigationPriceInfo.vue';
  import jsGlobalConfig from '../../../bps/globals/jsGlobalConfig';
  import ProductDetails from '../../../bps/types/ProductDetails';

  @Options({
    name: 'sale-box-bar',
    components: {
      ProductNavigationPriceInfo,
      AvailabilityInfo,
    }
  })
  export default class SaleBoxBar extends Vue {
    @Prop({default: false})
    readonly onePageCheckout: boolean;

    state: string = '';
    basketUrl = jsGlobalConfig().getBasketUrl();

    get productDetails(): ProductDetails {
      return productStore.productDetails;
    }

    get product(): Product {
      return productStore.productDetails.product;
    }

    get selectedQty(): number {
      return productStore.selectedQty;
    }

    set selectedQty(value: number) {
      productStore.selectedQty = value;
    }

    get selectedRecurringOrderFrequency() {
      return productStore.selectedRecurringOrderFrequency;
    }

    get addToBasketHtmlReplacement(): string {
      return productStore.productDetails.addToBasketHtmlReplacement;
    }

    @Watch('selectedQty')
    onSelectedQtyChange() {
      const qtyInput: any = this.$refs.quantity;
      qtyInput.setValue(this.selectedQty);
    }

    counterChangeHandler(value) {
      this.selectedQty = value;
      productPageService.changeQuantity(this.product.itemId, value);
    }

    addToBasket() {
      this.state = 'loadingBasket';
      productPageService.addToBasketFromStore(productStore.selectedQty, this.selectedRecurringOrderFrequency)
        .then(() => {
          this.state = '';
        });
    }

    scrollToCheckout() {
      const el = document.querySelector('.product-detailed-page__section--opc');
      scrollToElement(el, {offset: -this.$el.getBoundingClientRect().height, duration: 400});
    }

    isPriceInfoVisible() {
      if (this.productDetails.product.recurringOrderFollowUpPacket && !this.productDetails.product.zeroPriceItem) {
        return this.productDetails.product.recurringOrderFollowUpPriceEnabled;
      }
      return !this.productDetails.product.zeroPriceItem && !this.productDetails.product.recurringOrderFollowUpPacket;
    }
  }
</script>

